import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import api from '../../libs/axios';
import Breadcrumb from '../../utils/breadcrumbs';
import { ListLoader } from '../../utils/loader';

interface OrphanItem { id: number; name: string; pending_claims: number; }

const Orphaned: React.FC = () => {
  const [teams, setTeams] = useState<OrphanItem[]>([]);
  const [tournaments, setTournaments] = useState<OrphanItem[]>([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try { const res: any = await api.get('/ownership-claims/orphaned'); setTeams(res.data?.teams || []); setTournaments(res.data?.tournaments || []); }
    catch (e) { toast.error('Failed to load orphaned entities'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const assign = async (entity_type: string, entity_id: number) => {
    const user_id = window.prompt(`Assign ${entity_type} #${entity_id} to which user ID?`);
    if (!user_id) return;
    try { await api.post('/ownership-claims/assign', { entity_type, entity_id, user_id: Number(user_id) }); toast.success('Assigned'); load(); }
    catch (e) { toast.error('Assign failed'); }
  };

  const renderTable = (title: string, items: OrphanItem[], type: string) => (
    <div className="bg-white border border-gray-200 rounded-xl overflow-hidden mb-6">
      <div className="px-4 py-3 border-b border-gray-100 text-sm font-semibold text-gray-900">{title}</div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-gray-600"><tr>
            <th className="text-left font-medium px-4 py-3">Name</th>
            <th className="text-left font-medium px-4 py-3">Pending claims</th>
            <th className="text-right font-medium px-4 py-3">Action</th>
          </tr></thead>
          <tbody>
            {items.length === 0 ? <tr><td colSpan={3} className="px-4 py-8 text-center text-gray-400">None</td></tr> :
              items.map((it) => (
                <tr key={it.id} className="border-t border-gray-100">
                  <td className="px-4 py-3 text-gray-900">#{it.id} {it.name}</td>
                  <td className="px-4 py-3"><span className={`px-2 py-1 rounded-full text-xs ${it.pending_claims > 0 ? 'bg-yellow-100 text-yellow-800' : 'bg-gray-100 text-gray-600'}`}>{it.pending_claims}</span></td>
                  <td className="px-4 py-3 text-right"><button onClick={() => assign(type, it.id)} className="text-xs text-primary-700 hover:underline">Reassign</button></td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div className="p-4 sm:p-6">
      <Breadcrumb />
      <div className="mt-4 mb-6">
        <h1 className="text-xl font-semibold text-gray-900">Orphaned Entities</h1>
        <p className="text-sm text-gray-500">Teams / tournaments whose owner deleted their account. Reassign to a member, or review claims.</p>
      </div>
      {loading ? <ListLoader /> : (<>{renderTable('Orphaned teams', teams, 'team')}{renderTable('Orphaned tournaments', tournaments, 'tournament')}</>)}
    </div>
  );
};
export default Orphaned;
